import React from "react";
import {
  Button,
  EmployeeHeader,
  NoData,
  PageHeader,
} from "../../../../components";
import { useNavigate } from "react-router-dom";

const OnboardingDocuments = () => {
  const navigate = useNavigate();
  return (
    <div className="mt-3 flex-1 flex flex-col gap-2 ">
      <div>
        <PageHeader
          Section={<EmployeeHeader />}
          RightSection={
            <div className="flex gap-3">
              <Button
                color="primary"
                size="sm"
                title={"Back"}
                icon={"west"}
                type="link"
                to="/employee"
              />
              {/* <Button
                size="sm"
                title={"Back"}
                icon={"west"}
                // onClick={() => navigate("/employee/employee-profile#invoices")}
                onClick={() =>
                  navigate("/employee/employee-profile?profile-info=invoices")
                }
              /> */}
              {/* <Button
                size="sm"
                title={"Next"}
                icon={"east"}
                iconPosition="after"
              /> */}
            </div>
          }
        />
      </div>
      {/* Onboarding Documents */}
      <NoData />
    </div>
  );
};

export default OnboardingDocuments;
